import { render, staticRenderFns } from "./SelectBoard.vue?vue&type=template&id=790a5eba&scoped=true"
import script from "./SelectBoard.vue?vue&type=script&lang=js"
export * from "./SelectBoard.vue?vue&type=script&lang=js"
import style0 from "./SelectBoard.vue?vue&type=style&index=0&id=790a5eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790a5eba",
  null
  
)

export default component.exports